import Vue from 'vue';
import VueResource from 'vue-resource';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VeeValidate from 'vee-validate';
import VueCookie from 'vue-cookie';
import VueClipboard from 'vue-clipboard2';
import App from './App.vue';
import VueAnalytics from 'vue-analytics';
import { ApplicationConstants } from './shared/applicationConstants';
import GalleryComponent from './gallery/gallery.vue';
import HomeComponent from './home/home.vue';
import HomeGeolocalComponent from './home-geolocal/home-geolocal.vue';
import HomeEuroRegioComponent from './home-euroregio/home-euroregio.vue';
import LoginComponent from './login/login.vue';
import RegistreComponent from './registre/registre.vue';
import OblidatComponent from './oblidat/oblidat.vue';
import RenovarComponent from './renovar/renovar.vue';
import PerfilComponent from './perfil/perfil.vue';
import PoliticaComponent from './politica/politica.vue';
import { LoginService } from './login/services/loginService';

Vue.use(VueI18n);
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VueAwesomeSwiper);
Vue.use(VeeValidate);
Vue.use(VueCookie);
Vue.use(VueClipboard);

const i18n = new VueI18n({
    locale: ApplicationConstants.defaultLanguageCode,
});

const router = new VueRouter({
    routes: [{
            path: '/',
            name: 'home',
            component: HomeComponent,
            props: { hasBreadcrumbs: false },
        },
        {
            path: '/geolocal',
            name: 'geolocal',
            component: HomeGeolocalComponent,
            props: { hasBreadcrumbs: false },
        },
        {
            path: '/euroregio',
            name: 'euroregio',
            component: HomeEuroRegioComponent,
            props: { hasBreadcrumbs: false },
        },
        {
            path: '/gallery',
            name: 'gallery',
            component: GalleryComponent,
            props: { hasBreadcrumbs: true },
        },
        {
            path: '/login',
            name: 'login',
            component: LoginComponent,
            props: { hasBreadcrumbs: false },
        },
        {
            path: '/registre',
            name: 'registre',
            component: RegistreComponent,
            props: { hasBreadcrumbs: false },
        },
        {
            path: '/oblidat',
            name: 'oblidat',
            component: OblidatComponent,
            props: { hasBreadcrumbs: false, selectedLang: i18n.locale },
        },
        {
            path: '/renovar/:token',
            name: 'renovar',
            component: RenovarComponent,
            props: { hasBreadcrumbs: false },
        },
        {
            path: '/politica',
            name: 'politica',
            component: PoliticaComponent,
            props: { hasBreadcrumbs: false },
        },
        {
            path: '/perfil',
            name: 'perfil',
            component: PerfilComponent,
            beforeEnter: (to, from, next) => {
                if(LoginService.isUserLogged()){
                    next();
                }else{
                    next('/');
                }
            },
            props: { hasBreadcrumbs: true },
        },
    ],
});

Vue.use(VueAnalytics, {
    id: 'UA-46332195-12',
    checkDuplicatedScript: true,
    router,
});

const app = new Vue({
    el: '#app',
    i18n,
    router,
    methods: {
        setLocale: function(value) {
            i18n.locale = value;
        },
    },
    render: h => h(App),
});

app.$on('langchanged', function(value) {
    this.setLocale(value);
});



// WEBPACK FOOTER //
// ./src/main.js